import { useMutation } from '@apollo/client';
import { DislikeChatMessageDocument } from './DislikeChatMessage.gql';
export function useDislikeChatMessage() {
    const [mutate, state] = useMutation(DislikeChatMessageDocument);
    const handler = (input) => mutate({ variables: { input } });
    return [handler, state];
}
